module.exports = __webpack_public_path__ + "img/mainPicture.9f15ca5a.png";